import React from 'react';

import { Chip, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import RichardMonogram from '../chat/RichardMonogram';

const STARTER_QUESTIONS = [
  'How many orders did we take yesterday, by brand?',
  'Top 10 hotels by revenue last week',
  'Weekly orders for the last 8 weeks as a chart',
];

export default function EmptyState({ onAsk }: { onAsk: (question: string) => void }) {
  const theme = useTheme();
  return (
    <Stack spacing={2.5} alignItems="center" sx={{ py: 10, textAlign: 'center' }} data-testid="ui-stream-empty">
      <RichardMonogram inverted={theme.palette.mode === 'dark'} titleAccess="askRichard" sx={{ fontSize: 44 }} />
      <Typography variant="h5" sx={{ fontWeight: 500 }}>
        What do you want to know?
      </Typography>
      <Stack direction="row" spacing={1} flexWrap="wrap" justifyContent="center" useFlexGap>
        {STARTER_QUESTIONS.map((question) => (
          <Chip key={question} label={question} variant="outlined" onClick={() => onAsk(question)} />
        ))}
      </Stack>
    </Stack>
  );
}
